import { qsa, add } from "@fluorescent/dom";

import { section } from "@/glow";
import { backgroundVideoHandler } from "@/lib/a11y";
import autoPlay from "@/lib/autoPlay";
import { AnimateVideoHero } from "@/lib/animation";
import { setScreenHeightVars } from "../utils";

const selectors = {
  video: ".video-hero__video",
};

section("video-hero", {
  videoHandler: null,

  onLoad() {
    const video = qsa(selectors.video, this.container);

    // Use px instead of default vh for height vars to avoid CLS within section previews
    if (window.Shopify.visualPreviewMode === true) {
      add(this.container, "visual-preview");
      setScreenHeightVars(this.container);
    }

    if (video.length) {
      this.videoHandler = backgroundVideoHandler(this.container);
      autoPlay(video);
    }
    this.AnimateVideoHero = AnimateVideoHero(this.container);
  },

  onUnload() {
    this.videoHandler && this.videoHandler();
    this.AnimateVideoHero?.destroy();
  },
});
